import homeAccordion from "../../../resources/scripts/module/accordion";

const {registerBlockType} = wp.blocks;
const {RichText, MediaUpload, MediaUploadCheck} = wp.blockEditor;
const {Button} = wp.components;
const {useEffect} = wp.element;

import platformTabs from '../../../resources/scripts/module/tabs';

registerBlockType('mailmetrics/platform-tabs-dynamic', {
  title: 'Dynamic Platform Tabs',
  icon: 'welcome-add-page',
  category: 'layout',
  attributes: {
    mainHeading: {
      type: 'string',
      default: 'Our platform'
    },
    subHeading: {
      type: 'string',
      default: 'We create the perfect platform for your organisation by combining up to five key services.'
    },
    tabs: {
      type: 'array',
      default: [],
    }
  },
  edit: ({attributes, setAttributes}) => {
    const {mainHeading, subHeading, tabs} = attributes;

    useEffect(() => {
      platformTabs();

      return () => {
      };
    }, [tabs.length]);

    const addTab = () => {
      const newTabs = [...tabs, {
        title: '',
        imageUrl: '',
        headerText: '',
        descriptionText: '',
        contentItems: []
      }];
      setAttributes({tabs: newTabs});
    };

    const removeTab = (index) => {
      const newTabs = tabs.filter((_, i) => i !== index);
      setAttributes({tabs: newTabs});
    };

    const updateTab = (newData, index) => {
      const newTabs = tabs.map((tab, i) => i === index ? {...tab, ...newData} : tab);
      setAttributes({tabs: newTabs});
    };

    const addContentItem = (tabIndex) => {
      const newTabs = tabs.map((tab, i) => {
        if (i === tabIndex) {
          return {
            ...tab,
            contentItems: [...tab.contentItems, {title: '', text: ''}]
          };
        }
        return tab;
      });
      setAttributes({tabs: newTabs});
    };

    const updateContentItem = (tabIndex, itemIndex, newData) => {
      const newTabs = tabs.map((tab, i) => {
        if (i === tabIndex) {
          return {
            ...tab,
            contentItems: tab.contentItems.map((item, j) => j === itemIndex ? {...item, ...newData} : item)
          };
        }
        return tab;
      });
      setAttributes({tabs: newTabs});
    };

    const removeContentItem = (tabIndex, itemIndex) => {
      const newTabs = tabs.map((tab, i) => {
        if (i === tabIndex) {
          return {
            ...tab,
            contentItems: tab.contentItems.filter((_, j) => j !== itemIndex)
          };
        }
        return tab;
      });
      setAttributes({tabs: newTabs});
    };

    return (
      <section className="tabs-accordion-section">
        <div className="inner">
          <div>
            <div className="top-wrapper">
              <RichText
                tagName="h1"
                value={mainHeading}
                onChange={(newText) => setAttributes({mainHeading: newText})}
                placeholder="Enter main heading..."
              />
              <RichText
                tagName="p"
                value={subHeading}
                onChange={(newText) => setAttributes({subHeading: newText})}
                placeholder="Enter sub heading..."
              />
            </div>
            <div className="bottom-wrapper" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500" data-aos-offset="300">
              <div className="tabs-container">
                <div className="tabs-tab-list">
                  {tabs.map((tab, index) => (
                    <div key={index} className={`tabs-tab-list-item ${index === 0 ? 'active' : ''}`} data-tab={index}>
                      <RichText
                        tagName="p"
                        value={tab.title}
                        onChange={(newText) => updateTab({title: newText}, index)}
                        placeholder={`Tab ${index + 1} Title`}
                      />
                      <Button isDestructive onClick={() => removeTab(index)}>
                        Remove Tab
                      </Button>
                    </div>
                  ))}
                  <Button isPrimary onClick={addTab}>
                    Add Tab
                  </Button>
                </div>
                <div className="tabs-tab-content">
                  {tabs.map((tab, index) => (
                    <div key={index} className={`tabs-tab-content-item ${index === 0 ? 'active' : ''}`} data-content={index}>
                      <div className="left-column">
                        <MediaUploadCheck>
                          <MediaUpload
                            onSelect={(media) => updateTab({imageUrl: media.url}, index)}
                            allowedTypes={['image']}
                            value={tab.imageId}
                            render={({open}) => (
                              <Button onClick={open} isDefault style={{ position: 'absolute' }}>
                                {!tab.imageId ? 'Select Image' : 'Replace Image'}
                              </Button>
                            )}
                          />
                        </MediaUploadCheck>
                        {tab.imageUrl && <img src={tab.imageUrl} alt={`Tab ${index + 1} Image`}/>}
                      </div>
                      <div className="right-column">
                        <RichText
                          tagName="h3"
                          value={tab.headerText}
                          onChange={(newText) => updateTab({headerText: newText}, index)}
                          placeholder={`Tab ${index + 1} Header`}
                        />
                        <div className="description">
                          <RichText
                            tagName="p"
                            value={tab.descriptionText}
                            onChange={(newText) => updateTab({descriptionText: newText}, index)}
                            placeholder={`Tab ${index + 1} Description`}
                          />
                        </div>
                        {tab.contentItems.map((item, itemIndex) => (
                          <p key={itemIndex}>
                            <RichText
                              tagName="i"
                              value={item.title}
                              onChange={(newText) => updateContentItem(index, itemIndex, {title: newText})}
                              placeholder={`Content ${itemIndex + 1} Title`}
                            />
                            <br/>
                            <RichText
                              tagName="span"
                              value={item.text}
                              onChange={(newText) => updateContentItem(index, itemIndex, {text: newText})}
                              placeholder={`Content ${itemIndex + 1} Text`}
                            />
                            <Button isDestructive onClick={() => removeContentItem(index, itemIndex)}>
                              Remove Content
                            </Button>
                          </p>
                        ))}
                        <Button isSecondary onClick={() => addContentItem(index)}>
                          Add Content Item
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  },
  save: ({attributes}) => {
    const {mainHeading, subHeading, tabs} = attributes;

    const generateAccordionItems = () => {
      return tabs.map((tab, index) => (
        <>
        <div key={index}
             data-img={tab.imageUrl}
             className={`accordion-item ${index === 0 ? 'accordion-item-active' : ''}`}>
          <button className="accordion-header">
            <span>{tab.title}</span>
          </button>
          <div className="accordion-content">
            <h3>{tab.headerText}</h3>
            <div className="description">
              <p>{tab.descriptionText}</p>
            </div>
            {tab.contentItems.map((item, itemIndex) => (
              <p key={itemIndex}>
                <i>{item.title}</i>
                <span>{item.text}</span>
              </p>
            ))}
          </div>
        </div>
        {index < tabs.length - 1 && <hr />}
        </>
      ));
    };

    return (
      <section className="tabs-accordion-section">
        <div className="inner">
          <div>
            <div className="top-wrapper">
              <h1>{mainHeading}</h1>
              <p>{subHeading}</p>
            </div>
            <div className="bottom-wrapper" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500" data-aos-offset="300">
              <div className="tabs-container">
                <div className="tabs-tab-list">
                  {tabs.map((tab, index) => (
                    <div key={index}
                         className={`tabs-tab-list-item ${index === 0 ? 'active' : ''}`}
                         data-tab={index}>
                      <p>{tab.title}</p>
                    </div>
                  ))}
                </div>
                <div className="tabs-tab-content">
                  {tabs.map((tab, index) => (
                    <div key={index}
                         className={`tabs-tab-content-item ${index === 0 ? 'active' : ''}`}
                         data-content={index}>
                      <div className="left-column">
                        {tab.imageUrl && <img src={tab.imageUrl} alt={`Tab ${index + 1} Image`}/>}
                      </div>
                      <div className="right-column">
                        <h3>{tab.headerText}</h3>
                        <div className="description">
                          <p>{tab.descriptionText}</p>
                        </div>
                        {tab.contentItems.map((item, itemIndex) => (
                          <p key={itemIndex}>
                            <i>{item.title}</i>
                            <span>{item.text}</span>
                          </p>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="accordion-container">
                <div className="section-content">
                  <div className="accordion-image">
                    <img id="accordion-content-image" className="accordion-content-image"
                         src={tabs.length > 0 ? tabs[0].imageUrl : ''} alt={tabs.length > 0 ? tabs[0].title : ''} />
                  </div>
                  <div className="accordion-wrapper">
                    <div data-accordion="tabs" className="accordion-container">
                      {generateAccordionItems()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
});
